<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="grow flex flex-col">
    <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
      <ng-template pTemplate>
        <div class="flex w-full h-full">
          <div class="w-3/4 h-full flex flex-col">
            <div class="flex flex-row gap-2">
              <div class="w-1/2 pr-4 mt-2">
                <prox-field label="On Allowance Violation">
                  <!-- <p-dropdown [disabled]="parent.isReadOnly()" [options]="programViolationRules"
                    optionLabel="description" optionValue="id" [(ngModel)]="program.allowanceProgramViolationRuleId"
                    [bzModel]="program" name="allowanceProgramViolationRuleId"></p-dropdown> -->
                  <p-select [disabled]="parent.isReadOnly()" [options]="programViolationRules"
                    optionLabel="description" optionValue="id" [(ngModel)]="program.allowanceProgramViolationRuleId"
                    [bzModel]="program" name="allowanceProgramViolationRuleId" class="w-full"></p-select>
                </prox-field>
              </div>
              <div class="w-1/2 mt-2">
                <prox-field label="Program Allowance Remainder Rule (all allowances in program)">
                  <!-- <p-dropdown [disabled]="parent.isReadOnly()" [options]="programAllowanceRemainderRules"
                    optionLabel="name" optionValue="id" [(ngModel)]="program.programAllowanceRemainderRuleId"
                    [bzModel]="program" name="programAllowanceRemainderRuleId"></p-dropdown> -->
                  <p-select [disabled]="parent.isReadOnly()" [options]="programAllowanceRemainderRules"
                    optionLabel="name" optionValue="id" [(ngModel)]="program.programAllowanceRemainderRuleId"
                    [bzModel]="program" name="programAllowanceRemainderRuleId" class="w-full"></p-select>
                </prox-field>
              </div>
            </div>
            <div class="flex">
              <div class="w-1/6 pt-4 pb-3">
                <button [disabled]="parent.isReadOnly() || !programAllowances" (click)="onPaAdd()" pButton type="button"
                  label="Add Allowance" icon="pi pi-plus" class="p-button-sm"></button>
              </div>
            </div>
            <div class="grow h-full pb-2">
              <prox-ag-grid gridId="programAllowancesGrid" [gridOptions]="paGridOptions"
                [rowData]="programAllowances"></prox-ag-grid>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate>
        <div class="flex w-full h-full">
          <div class="w-3/4 h-full flex flex-col">
            <p-splitter class="w-full grow" layout="horizontal" styleClass="h-full" [panelSizes]="[50, 50]">
              <ng-template pTemplate>
                <div class="flex flex-col w-full h-full pt-2">
                  <div class="flex gap-2 mb-2">
                    <p-button [disabled]="parent.isReadOnly() || !selectedPa" (click)="onPaSelectAllGroups()"
                      size="small" label="Select All" icon="pi pi-check-square"></p-button>
                    <p-button [disabled]="parent.isReadOnly() || !selectedPa" (click)="onPaDeselectAllGroups()"
                      size="small" label="Deselect All" icon="pi pi-square" severity="secondary"></p-button>
                  </div>
                  <div class="flex-1 h-full">
                    <prox-ag-grid gridId="availablePaPugsGrid" [gridOptions]="paPugGridOptions"
                      [rowData]="availablePaPugs" [hasColSizeButtons]="false"></prox-ag-grid>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate>
                <p-tabView class="w-full h-full qb-tabview">
                  <p-tabPanel header="Feature Price Exclusions">
                    <div class="w-full h-full">
                      <prox-ag-grid [gridOptions]="paFeatureGridOptions" [rowData]="paFeatures"
                        [hasFooter]="false"></prox-ag-grid>
                    </div>
                  </p-tabPanel>
                  <p-tabPanel header="Add-On Price Exclusions">
                    <div class="w-full h-full">
                      <prox-ag-grid [gridOptions]="paAddonGridOptions" [rowData]="paAddons"
                        [hasFooter]="false"></prox-ag-grid>
                    </div>
                  </p-tabPanel>
                </p-tabView>
              </ng-template>
            </p-splitter>
          </div>
        </div>
      </ng-template>
    </p-splitter>
  </div>
</div>